module.exports = __webpack_public_path__ + "static/media/Symbol.8a5b1308.svg";